import { Component, OnInit, Input, Output, EventEmitter, ViewChild, AfterViewInit } from '@angular/core';
import { RTQ } from 'src/app/shared/models/exercise.model';
import { UtilityService } from 'src/app/shared/utils/utility.service';
// import { RTQ } from 'src/app/models/exercise.model';
// import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-rtq',
  templateUrl: './rtq.component.html',
  styleUrls: ['./rtq.component.css']
})
export class RtqComponent implements OnInit, AfterViewInit {
  map: { [key: string]: string } = {};
  _element: RTQ;
  activeRow: number = 0;
  answersMap: any[];
  @Input() isResultPublished: boolean = false;
  @Input() immediateFeedBackRequired: boolean = false;
  @Input() showBackButton: boolean = false;
  @Input() id: string;
  @Input() userFeedback;
  @Output() reportFeedback = new EventEmitter<Object>();
  @Output() likeDislike = new EventEmitter<boolean>();
  @Input() isSubmitted: boolean = false;
  @Input() index: number;
  @Input() exerciseTimetrackingdata;
  _answer: any

  @Input() set answer(answer) {
    if (answer) {
      this._answer = answer;
      this.questionChecked = true;
    }
  }
  @Input() points: any;

  @Input() variableFeedback: any;
  @Input() fixedEditor: any;

  showNext: boolean = false;
  questionChecked: boolean = false;
  showSlick: boolean = false;
  @Input() set element(element) {
    this._element = element;
    if (this._element && this._element.options && this._element.options.length) {
      this._element.options.forEach(({ _id }) => this.map[_id] = '');
      this.answersMap = Array(this._element.options.length).fill('');
    }
  }
  @Output() onClick = new EventEmitter<Object>();
  @Output() onReview = new EventEmitter<Object>();
  @Output() back = new EventEmitter<Boolean>(false);
  @ViewChild('slickModalInner') slickModalInner: any;

  slideConfig1 = {
    dots: true,
    arrows: false,
    accessibility: false,
    swipe: false,
    touchMove: false,
    //vertical: true,
    fade: false,
    draggable: false,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 767,
      settings: {
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 550,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    ]
  };

  @Input() exerciseId;
  @Input() questionBlos;
  
  constructor(private utilitiyService: UtilityService) { }

  ngOnInit() {

    if (this.answer) {
      this.map = JSON.parse(this.answer);
      this.updateCorrectAnswers();
    }
  }

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    setTimeout(() => this.showSlick = true, 500)
  }

  updateCorrectAnswers(): any {
    for (let o in this.map) {
      let row = this._element.options.findIndex((i) => i._id == o);
      if (row > -1) {
        let j = this._element.options[row].rowsOptions.findIndex(i => i._id == this.map[o]);
        if (j > -1) {
          this.answersMap[row] = this.map[o];
        }
      }
    }
  }

  radioState(row, event, id) {
    setTimeout(() => {
      this.map[event] = id;
      if ((++row >= this._element.options.length)) {
        if (Object.keys(this.map).every(k => (this.map[k] && this.map[k].length > 0))) this.slickModalInner.slickNext();
        else return false;
      }
      else
        this.slickModalInner.slickNext();
    }, 500);
  }

  next() {
    this.onClick.emit({ elementId: this.id, answer: JSON.stringify(this.map) });
  }

  check() {
    let obj = { elementId: this.id, answer: JSON.stringify(this.map) }
    this.utilitiyService.evaluateQuestion({ exerciseId: this.exerciseId, answers: obj }).subscribe(data => {
      if (data) {
        this.variableFeedback = data.answerFeedback
        this.questionChecked = true;
        this.onReview.emit(obj);
      }
    });
  }

  skip() {
    this.onClick.emit({ elementId: this.id, answer: '' });
  }

  backHandler() {
    this.back.emit(true);

  }

  slickChange(e: { event: Event }) {
    e.event.stopImmediatePropagation();
    e.event.stopPropagation();
    e.event.preventDefault();
    return;
  }

  get questionAttempted() {
    let arr = Object.keys(this.map);
    return arr.length == this._element.options.length && arr.every(el => this.map[el].length > 0);
  }
  _reportFeedback() {
    this.reportFeedback.emit(this._element);
  }

  _likeDislike(like) {
    this.likeDislike.emit(like);
  }
}
